/* Enord Core classic v1.0 — video popup for en-banner-classic */
(function(){
  if(window.__enbInit)return;window.__enbInit=true;
  var modal=null;
  function close(){if(!modal)return;var v=modal.querySelector('video');if(v){v.pause();v.removeAttribute('src');v.load();}modal.remove();modal=null;document.removeEventListener('keydown',onKey);}
  function onKey(e){if(e.key==='Escape')close();}
  function open(src){
    close();
    modal=document.createElement('div');modal.className='enb-modal';modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');
    var box=document.createElement('div');box.className='enb-modal-box';
    var x=document.createElement('button');x.type='button';x.className='enb-modal-x';x.setAttribute('aria-label','Close');x.innerHTML='&times;';
    var v=document.createElement('video');v.controls=true;v.autoplay=true;v.playsInline=true;v.src=src;
    box.appendChild(x);box.appendChild(v);modal.appendChild(box);document.body.appendChild(modal);
    x.addEventListener('click',close);
    modal.addEventListener('click',function(e){if(e.target===modal)close();});
    document.addEventListener('keydown',onKey);
    var p=v.play();if(p&&p.catch)p.catch(function(){});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-enb-play]');
    if(!a)return;e.preventDefault();open(a.getAttribute('data-video'));
  });
})();
